import { useEffect } from 'react';

/**
 * SEO Component for dynamic meta tags per page
 * Updates document title and meta tags based on page content
 */
const SEO = ({ 
  title = "Free Restaurant Online Ordering Assessment - Grow Your Orders | Order Portal",
  description = "Take our free 5-minute assessment to discover how to increase your restaurant's online orders. Get customized insights for pizza, deli, Chinese, Mexican, Thai, Indian, and all restaurant types.",
  keywords = "restaurant online ordering, online ordering for restaurants, restaurant assessment, online ordering system",
  canonical = "https://assessment.getmyorderportal.com/",
  ogImage = "/myorderportal.png"
}) => {
  useEffect(() => {
    // Update title
    if (title) {
      document.title = title;
    }

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = keywords;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (canonicalLink) {
        canonicalLink.setAttribute('href', canonical);
      } else {
        canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        canonicalLink.href = canonical;
        document.getElementsByTagName('head')[0].appendChild(canonicalLink);
      }
    }

    // Update Open Graph tags
    const updateOGTag = (property, content) => {
      let ogTag = document.querySelector(`meta[property="${property}"]`);
      if (ogTag) {
        ogTag.setAttribute('content', content);
      } else {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', property);
        ogTag.setAttribute('content', content);
        document.getElementsByTagName('head')[0].appendChild(ogTag);
      }
    };

    if (title) updateOGTag('og:title', title);
    if (description) updateOGTag('og:description', description);
    if (canonical) updateOGTag('og:url', canonical);
    if (ogImage) updateOGTag('og:image', ogImage);

    // Update Twitter Card tags
    const updateTwitterTag = (name, content) => {
      let twitterTag = document.querySelector(`meta[name="${name}"]`);
      if (twitterTag) {
        twitterTag.setAttribute('content', content);
      } else {
        twitterTag = document.createElement('meta');
        twitterTag.setAttribute('name', name);
        twitterTag.setAttribute('content', content);
        document.getElementsByTagName('head')[0].appendChild(twitterTag);
      }
    };

    if (title) updateTwitterTag('twitter:title', title);
    if (description) updateTwitterTag('twitter:description', description);
    if (ogImage) updateTwitterTag('twitter:image', ogImage);

  }, [title, description, keywords, canonical, ogImage]);

  return null;
};

export default SEO;

